import ScoreByLessonLoading from './ScoreByLessonLoading';
export default ScoreByLessonLoading;
